// A hand-built projection of the entity, not a raw DB row: `organization`, `documentType` and
// `currentVersion` are relations, always `{ id }`, never nested further (`controllers.md`, "une
// relation sort par son identifiant"). The document type's label is resolved client-side via
// `DocumentTypesListView.labelOf`, never carried on this payload. `description` is never an
// empty string — the server transforms `''` to `null`.
export type DocumentTemplatePayload = {
	readonly id: number;
	readonly organization: { readonly id: number };
	readonly name: string;
	readonly description: string | null;
	readonly documentType: { readonly id: number };
	readonly archivedAt: string | null;
	readonly currentVersion: { readonly id: number };
};

export type DocumentTemplatesFetchedPayload = DocumentTemplatePayload[];

export type DocumentTemplatesFetchedAction = {
	type: 'DOCUMENT_TEMPLATES_FETCHED';
	payload: DocumentTemplatesFetchedPayload;
	organizationId: number;
};

export default (
	payload: DocumentTemplatesFetchedPayload,
	organizationId: number,
): DocumentTemplatesFetchedAction => ({
	type: 'DOCUMENT_TEMPLATES_FETCHED',
	payload,
	organizationId,
});
